import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { Button } from "@/components/ui/button";
import { TextInput } from "@/components/ui/textInput";
import { Typography } from "@/components/ui/typography";
import { inputStep, maxInputNumber } from "@/constants/inputs";
import useCUCompositeJobStore from "@/store/useCUCompositeJobStore";
import { getFloat } from "@/utils/mappings";

import ExpandableSection from "../../../../components/job/ExpandableSection";

const cardName = "utReadingSection";
const utReadingDetailsSchema = z.object({
  ut_readings: z.union([
    z.number().lt(maxInputNumber).gt(0.04),
    z.string().refine((value) => !isNaN(Number.parseFloat(value)), { message: "Must be a number" }),
  ]),
});
type UtReadingDetailsSchema = z.infer<typeof utReadingDetailsSchema>;
export function UTReadingDetails() {
  const { sections, toggleExpandableSection, setUTReadingDetails } = useCUCompositeJobStore();
  const savedData = sections.utReadingSection?.data;

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<UtReadingDetailsSchema>({
    resolver: zodResolver(utReadingDetailsSchema),
    values: {
      ut_readings: savedData?.ut_readings ?? "",
    },
  });

  return (
    <ExpandableSection
      status={sections.utReadingSection?.status ?? "hidden"}
      setIsExpanded={() => toggleExpandableSection(cardName)}
      title="UT Reading Details"
    >
      <div>
        <form
          className="flex flex-col items-center gap-6 md:flex-row md:gap-20"
          onSubmit={handleSubmit((data) => {
            if (!data.ut_readings) return;
            const ut_readings =
              typeof data.ut_readings === "string" ? Number.parseFloat(data.ut_readings) : data.ut_readings;
            setUTReadingDetails({ data: { ut_readings }, status: "done" });
          })}
        >
          <TextInput
            className="flex-1 basis-full md:basis-60"
            label="UT reading"
            type="number"
            step={inputStep}
            error={errors.ut_readings?.message}
            {...register("ut_readings", { setValueAs: getFloat })}
            endAdornment={
              <Typography variant="text-small" weight="regular" className="text-gray-400">
                Inches
              </Typography>
            }
          />
          <Button className="w-full self-end md:w-fit" type="submit">
            Save
          </Button>
        </form>
      </div>
    </ExpandableSection>
  );
}
